import { render, staticRenderFns } from "./OffLabelAgreementForm.vue?vue&type=template&id=31e5a8fd&scoped=true"
import script from "./OffLabelAgreementForm.vue?vue&type=script&lang=js"
export * from "./OffLabelAgreementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5a8fd",
  null
  
)

export default component.exports